import { Role } from '@/app/modules/Security/models/Authorization';

import { type MenuItem } from './types';

function getAvailableOptions(options: Array<MenuItem>, roles: Array<string>): Array<MenuItem> {
  const available: Array<MenuItem> = [];
  options.forEach((op) => {
    const intersection: boolean = (op.roles ?? []).some((item) => roles.includes(item));
    if (intersection || (op.roles ?? []).length === 0) {
      available.push({
        ...op,
        children: getAvailableOptions(op.children, roles)
      });
    }
  });

  return available;
}

export function GetMenuItems(roles: Array<string>): Array<MenuItem> {
  return getAvailableOptions(menuItems, roles);
}

const menuItems: Array<MenuItem> = [
  {
    id: 'security',
    url: '',
    roles: [],
    children: [
      { id: 'users', url: '/administration/user', roles: [Role.UsersAdmin], children: [] },
      {
        id: 'user-taxpayers',
        url: '/administration/taxpayers',
        roles: [Role.TaxpayersAdmin],
        children: []
      },
      {
        id: 'two-factor-authentication',
        url: '/security/twoFactorAuthentication',
        roles: [],
        children: []
      },
      {
        id: 'disable-tfa-to-user',
        url: '/administration/disable-tfa-to-user',
        roles: [Role.TfaAdmin],
        children: []
      },
      {
        id: 'audit-log-security-http',
        url: '/security/logs/security/http',
        roles: [Role.SystemAuditor],
        children: []
      },
      {
        id: 'audit-log-application-http',
        url: '/security/logs/application/http',
        roles: [Role.SystemAuditor],
        children: []
      }
    ]
  },
  {
    id: 'configuration',
    url: '',
    roles: [
      Role.CatalogsAdmin,
      Role.EnvironmentsAdmin,
      Role.TaxpayersAdmin,
      Role.NotificationsAdmin
    ],
    children: [
      {
        id: 'terms-template',
        url: '/parameters/terms-template',
        roles: [Role.EnvironmentsAdmin],
        children: []
      },
      {
        id: 'home-template',
        url: '/parameters/home-template',
        roles: [Role.EnvironmentsAdmin],
        children: []
      },
      {
        id: 'notifications-application',
        url: '/parameters/application/notification-template',
        roles: [Role.NotificationsAdmin],
        children: []
      },
      {
        id: 'notifications-security',
        url: '/parameters/security/notification-template',
        roles: [Role.NotificationsAdmin],
        children: []
      },
      {
        id: 'environment-application',
        url: '/parameters/application/environment',
        roles: [Role.EnvironmentsAdmin],
        children: []
      },
      {
        id: 'environment-security',
        url: '/parameters/security/environment',
        roles: [Role.EnvironmentsAdmin],
        children: []
      },
      {
        id: 'catalog',
        url: '/parameters/catalog-type',
        roles: [Role.CatalogsAdmin],
        children: []
      },
      {
        id: 'taxpayer-fields',
        url: '/parameters/taxpayer-fields',
        roles: [Role.TaxpayersAdmin],
        children: []
      }
    ]
  },
  { id: 'operations', url: '', roles: [Role.FormsAdmin], children: [] },
  {
    id: 'taxpayers',
    url: '',
    roles: [
      Role.TaxpayerReports,
      Role.TaxpayersApprover,
      Role.AccountReports,
      Role.TaxpayersAdmin,
      Role.CurrentAccountAdmin
    ],
    children: [
      {
        id: 'taxpayer-feedback',
        url: '/taxpayer/feedback',
        roles: [Role.TaxpayersAdmin],
        children: []
      },
      {
        id: 'taxpayer-requests',
        url: '/taxpayer/request-evaluation',
        roles: [Role.TaxpayersApprover],
        children: []
      },
      {
        id: 'taxpayer-report',
        url: '/taxpayer/report',
        roles: [Role.TaxpayerReports],
        children: []
      },
      {
        id: 'currentAccount',
        url: '/current-account',
        roles: [Role.AccountReports],
        children: []
      },
      {
        id: 'currentAccountJurisdiction',
        url: '/current-account/jurisdiction',
        roles: [Role.AccountReports],
        children: []
      },
      // {
      //   id: 'taxofficer-transaction-adjustment',
      //   url: '/taxpayer/transaction-adjustment',
      //   roles: [Role.CurrentAccountAdmin],
      //   children: []
      // },
      {
        id: 'send-message-taxpayer',
        url: '/taxpayer/create-communication',
        roles: [Role.TaxpayerCommunication],
        children: []
      }
    ]
  },
  {
    id: 'taxes',
    url: '',
    roles: [Role.FormsAdmin],
    children: [
      {
        id: 'economy-activity',
        url: '/operations/economy-activity',
        roles: [Role.FormsAdmin],
        children: []
      },
      {
        id: 'manage-tax',
        url: '/taxes/manage/taxes',
        roles: [Role.FormsAdmin],
        children: []
      },
      {
        id: 'manage-form',
        url: '/tax-statement/form/administration',
        roles: [Role.FormsAdmin],
        children: []
      }
      // {
      //   id: 'manage-report',
      //   url: '/taxes/manage/complementary',
      //   roles: [Role.FormsAdmin],
      //   children: []
      // },
      // {
      //   id: 'manage-report-operations',
      //   url: '/taxes/manage/reports',
      //   roles: [Role.FormsAdmin],
      //   children: []
      // }
    ]
  },
  { id: 'statements-tax-officer', url: '', roles: ['admin', 'taxreturn_approver'], children: [] },
  {
    id: 'reports',
    url: '',
    roles: [Role.DetailsReports, Role.TaxreturnReports],
    children: [
      {
        id: 'taxreport-report',
        url: '/reports/taxreturn',
        roles: [Role.TaxreturnReports],
        children: []
      }
      // {
      //   id: 'taxreturn-evaluation',
      //   url: '/statements/taxreturn-evaluation',
      //   roles: [Role.TaxreturnApprover],
      //   children: []
      // },
      // {
      //   id: 'report-details',
      //   url: '/reports/details',
      //   roles: [Role.DetailsReports],
      //   children: []
      // }
    ]
  },
  {
    id: 'taxofficer-taxreturn-payments',
    url: '',
    roles: [],
    children: [
      {
        id: 'query-payments-taxofficer',
        url: '/payments/declaration/view',
        roles: [Role.PaymentsAdmin],
        children: []
      },
      {
        id: 'taxofficer-payment-record',
        url: '/payments/declaration/tax-return',
        roles: [Role.PaymentsAdmin],
        children: []
      },
      {
        id: 'taxofficer-upload-payments',
        url: '/payments/bank/upload',
        roles: [Role.PaymentsAdmin],
        children: []
      },
      {
        id: 'taxofficer-check-load-payments',
        url: '/payments/bank/view',
        roles: [Role.PaymentsAdmin],
        children: []
      },
      {
        id: 'taxofficer-reconciliation-payments',
        url: '/payments/match',
        roles: [Role.PaymentsAdmin],
        children: []
      }
    ]
  },
  {
    id: 'disbursement',
    url: '',
    roles: [Role.DisbursementManage, Role.DisbursementView],
    children: [
      {
        id: 'disbursementView',
        url: '/disbursement/view',
        roles: [Role.DisbursementView, Role.DisbursementManage],
        children: []
      },
      {
        id: 'disbursementManage',
        url: '/disbursement/manage',
        roles: [Role.DisbursementManage],
        children: []
      }
    ]
  },
  {
    id: 'management-report',
    url: '',
    roles: [Role.ManagementReportAdmin],
    children: [
      {
        id: 'management-report-taxpayer',
        url: '/management-report/taxpayer',
        roles: [Role.ManagementReportAdmin],
        children: []
      },
      {
        id: 'management-report-taxreturn',
        url: '/management-report/taxreturn',
        roles: [Role.ManagementReportAdmin],
        children: []
      },
      {
        id: 'management-report-payment',
        url: '/management-report/payment',
        roles: [Role.ManagementReportAdmin],
        children: []
      }
    ]
  }
  // {
  //   id: 'collection_compliance',
  //   url: '',
  //   roles: [
  //     Role.DebtCollectionOfficer,
  //     Role.DebtCollectionManager,
  //     Role.DebtCollectionAnalyst,
  //     Role.NonComplianceAnalyst,
  //     Role.CollectionStatistics,
  //     Role.ComplianceStatistics
  //   ],
  //   children: [
  //     {
  //       id: 'debt_collection_manage',
  //       url: '/collections/view-process',
  //       roles: [Role.DebtCollectionManager],
  //       children: []
  //     },
  //     {
  //       id: 'non_compliance',
  //       url: '/non-compliances',
  //       roles: [Role.NonComplianceAnalyst],
  //       children: []
  //     },
  //     {
  //       id: 'collection_statistics',
  //       url: '/collections/statistics',
  //       roles: [Role.CollectionStatistics],
  //       children: []
  //     },
  //     {
  //       id: 'compliance_statistics',
  //       url: '/non-compliances/statistics',
  //       roles: [Role.ComplianceStatistics],
  //       children: []
  //     },
  //     {
  //       id: 'configure_penalties',
  //       url: '/penalties',
  //       roles: [Role.DebtCollectionManager],
  //       children: []
  //     }
  //   ]
  // }
];
